/**
 * Use Case: Deletar Tarefa
 * Orquestra a exclusão de uma tarefa
 */

import { ITaskRepository } from '../../../domain/repositories/ITaskRepository';
import { NotFoundError } from '../../../core/errors/DomainErrors';

export class DeleteTaskUseCase {
    constructor(private readonly taskRepository: ITaskRepository) { }

    async execute(taskId: string): Promise<void> {
        // Executa exclusão diretamente
        // A validação de existência é feita pelo repositório
        await this.taskRepository.delete(taskId);
    }
}
